import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { documentaryResourcesRetrieve } from "@shared-kernel/application/use-cases/documentary-resources/retrieval/documentary-resources-retrieve";
import { documentaryResourceConsultationLog } from "@shared-kernel/application/use-cases/documentary-resources/consultation-logging/documentary-resource-consultation-log";
import { selectDocumentaryResourcesForConsultation } from "@shared-kernel/application/use-cases/documentary-resources/retrieval/selectors/documentary-resources-selectors";
import { DocumentaryResourcesContent } from "@shared-kernel/primary/shared/documentary-resources/documentary-resources.content";
import { DocumentaryResourcesSkeleton } from "@shared-kernel/primary/shared/documentary-resources/documentary-resources.skeleton";

interface Props {
  title?: string;
  subtitle?: string;
}

export const DocumentaryResourcesContainer = ({ title, subtitle }: Props) => {
  const dispatch = useAppDispatch();
  const { groups, isLoading } = useAppSelector(selectDocumentaryResourcesForConsultation);

  useEffect(() => {
    dispatch(documentaryResourcesRetrieve());
  }, [dispatch]);

  // Le PDF s'ouvre nativement via le lien (nouvel onglet). En parallèle on enregistre la
  // consultation ; sur succès on rafraîchit la liste pour mettre à jour le badge « lu » + la date.
  // Un échec du log ne casse pas l'ouverture (rejet ignoré).
  const onOpen = useCallback(
    (resourceId: string) => {
      dispatch(documentaryResourceConsultationLog(resourceId))
        .unwrap()
        .then(() => {
          dispatch(documentaryResourcesRetrieve());
        })
        .catch(() => {
          // Log non bloquant : on n'interrompt pas l'utilisateur si l'enregistrement échoue.
        });
    },
    [dispatch],
  );

  if (isLoading) return <DocumentaryResourcesSkeleton title={title} />;

  return <DocumentaryResourcesContent groups={groups} onOpen={onOpen} title={title} subtitle={subtitle} />;
};
